import React, { useState, useEffect } from 'react';
import HeaderCardNew from '../../Components/HeaderCardNew';
import FlexibleCard from '../../Components/FlexibleCard';
import CarouselSmallCard from '../../Components/CarouselSmallCard';
import FeedbackCard from '../../Components/FeedbackCard';
import BannerCardWithLinkEsVE from "../../Components/BannerCardWithLinkEsVE";
import TopNavBarNew from "../../Components/TopNavBarNew";
import BottomNavBarNew from "../../Components/BottomNavBarNew";
import styles from '../AbortionWPills/PillAbortion.module.css';
/* import * as ContentfulMarkdown from 'react-markdown'; */

export default function Diafragma({ appLanguage }) {
  const [pageState, setPageState] = useState({
    // General Content
    headerTitle: '',
    pageTitle: '',
    extraText: '',
    extraText2: '',
    extraText3: '',

    // Individual Large Cards
    largeCard1: {},
    largeCard2: {},
    largeCard3: {},
    largeCard4: {},
    largeCard5: {},
    largeCard6: {},

    // Small Cards Section
    smallCardTitle1: '',
    smallCardDescription1: '',
    smallCardTitle2: '',
    smallCardDescription2: '',

    // Banner Card
    bannerCardDescription1: '',

    // Assets
    headerImage: '',
    arrowIconWhite: '',
    arrowIconDark: '',
    heartIcon: '',
    image1: '',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Diaphragm';

    const entries = JSON.parse(localStorage.getItem('ayaAppEntries') || '[]');
    const assets = JSON.parse(localStorage.getItem('ayaAppAssets') || '[]');

    const getEntryById = (id) => entries.find((entry) => entry.sys.id === id);
    const getField = (entry, fieldName, locale) => entry?.fields?.[fieldName]?.[locale] || '';
    const getAssetUrlById = (id, language = appLanguage || 'es-VE') => {
      const asset = assets.find((a) => a.sys.id === id);
      if (!asset?.fields?.file) return '';

      const localizedFile = asset.fields.file[language];
      if (localizedFile?.url) {
        const url = localizedFile.url;
        return url.startsWith('//') ? `https:${url}` : url;
      }

      const fallbackFile = Object.values(asset.fields.file)[0];
      if (fallbackFile?.url) {
        const url = fallbackFile.url;
        return url.startsWith('//') ? `https:${url}` : url;
      }

      return '';
    };

    const abortionEntry = getEntryById('67ybDNkDChu5cyrnJKgbhD');
    const largeCardEntry = getEntryById('1a34pQzcnNvi7PcS0nK22e');

    setPageState({
      headerTitle: getField(abortionEntry, 'headerTitle', appLanguage),
      pageTitle: getField(abortionEntry, 'pageTitle', appLanguage),
      extraText: getField(abortionEntry, 'extraText', appLanguage),
      extraText2: getField(abortionEntry, 'extraText2', appLanguage),
      extraText3: getField(abortionEntry, 'extraText3', appLanguage),

      bannerCardDescription1: getField(abortionEntry, 'bannerCardDescription1', appLanguage),

      smallCardTitle1: getField(abortionEntry, 'smallCardTitle1', appLanguage),
      smallCardDescription1: getField(abortionEntry, 'smallCardDescription1', appLanguage),
      smallCardTitle2: getField(abortionEntry, 'smallCardTitle2', appLanguage),
      smallCardDescription2: getField(abortionEntry, 'smallCardDescription2', appLanguage),

      largeCard1: {
        ovalText: getField(abortionEntry, 'pageTitle', appLanguage),
        blackTitle: getField(largeCardEntry, 'largeCardTitle1', appLanguage),
        blueTitle: getField(largeCardEntry, 'largeCardTitle7', appLanguage),
        description: getField(largeCardEntry, 'largeCardDescription1', appLanguage),
        images: [{ url: getAssetUrlById('4f2mek3L6ftTbff7F1cPWY') }],
      },
      largeCard2: {
        blackTitle: getField(largeCardEntry, 'largeCardTitle2', appLanguage),
        description: getField(largeCardEntry, 'largeCardDescription2', appLanguage),
      },
      largeCard3: {
        blackTitle: getField(largeCardEntry, 'largeCardTitle3', appLanguage),
        description: getField(largeCardEntry, 'largeCardDescription3', appLanguage),
      },
      largeCard4: {
        blackTitle: getField(largeCardEntry, 'largeCardTitle4', appLanguage),
        description: getField(largeCardEntry, 'largeCardDescription4', appLanguage),
      },
      largeCard5: {
        blackTitle: getField(largeCardEntry, 'largeCardTitle5', appLanguage),
        description: getField(largeCardEntry, 'largeCardDescription5', appLanguage),
      },
      largeCard6: {
        blackTitle: getField(largeCardEntry, 'largeCardTitle6', appLanguage),
        description: getField(largeCardEntry, 'largeCardDescription6', appLanguage),
      },

      headerImage: getAssetUrlById('4PRStO660MxXni9z6sY8j8'),
      arrowIconWhite: getAssetUrlById('5t0SZSeDrtBlIZ3o0Apjcu'),
      arrowIconDark: getAssetUrlById('h150pgUHcW5LIJwnFodWZ'),
      heartIcon: getAssetUrlById('740H3V1s40GxiaZiqj79MY'),
      image1: getAssetUrlById('4f2mek3L6ftTbff7F1cPWY'),
      image2: getAssetUrlById(''),
    });
  }, [appLanguage]);

  return (
    
      <div className={styles.libraryAbortionMenuContainer}>
        <TopNavBarNew backgroundColor="#E3F4FF" breadcrumbColor="#333" />
        {/* Header Section */}
        <div className={styles.headerContainerContraception}>
          <HeaderCardNew
            title={pageState.headerTitle}
            image={pageState.headerImage}
            backgroundColor="#E3F4FF"
            borderRadius="0px"
          />
        </div>
        <div className={styles.bottomSpace}></div>
        <div className={styles.homePageContainer}>
        {/* Render Large Cards */}
          <FlexibleCard
            blueTitle={pageState.largeCard1.blueTitle}
            blackTitle={pageState.largeCard1.blackTitle}
            description={pageState.largeCard1.description}
            images={pageState.largeCard1.images}
            imagePosition="below-blue-title"
            imageWidth="127px"
            blackTitleFontSize="13px"
            showOval={true}
            ovalText={pageState.largeCard1.ovalText}
            showSecondOval={true}
            secondOvalText={pageState.largeCard1.ovalText2}
            width="351px"
            borderRadius="10px"
          />

        <FlexibleCard
          blackTitle={pageState.largeCard2.blackTitle}
          description={pageState.largeCard2.description}
          width="351px"
          borderRadius="10px"
        />

        <FlexibleCard
          blackTitle={pageState.largeCard3.blackTitle}
          description={pageState.largeCard3.description}
          width="351px"
          borderRadius="10px"
        />

        <FlexibleCard
          blackTitle={pageState.largeCard4.blackTitle}
          description={pageState.largeCard4.description}
          width="351px"
          borderRadius="10px"
        />

        {/* Condom Link Card */}
        <BannerCardWithLinkEsVE
          linkPath="/contra-barrier-condom"
          descriptionEn="There is no protection against STIs with this method. Remember to use a condom to protect yourself."
          descriptionEs="No hay protección contra las ITS con este método. Recuerda usar un condón para protegerte."
          appLanguage={appLanguage}
        />

        <FlexibleCard
          blackTitle={pageState.largeCard5.blackTitle}
          description={pageState.largeCard5.description}
          imagePosition="below-title"
          width="351px"
          borderRadius="10px"
        />

        <FlexibleCard
          blackTitle={pageState.largeCard6.blackTitle}
          description={pageState.largeCard6.description}
          imagePosition="below-title"
          width="351px"
          borderRadius="10px"
        />

        {/* Extra Section */}
        <div className={styles.extraTitle}>{pageState.extraText}</div>

        {/* Feedback Card Section */}
        <FeedbackCard title={pageState.extraText2} appLanguage={appLanguage} />

        <div className={styles.leftAlignWrapper}>
        {/* Extra Section */}
        <div className={styles.extraTitletwo}>{pageState.extraText3}</div>

        {/* Small Cards */}
        {pageState.smallCardTitle1 && (
          <div className={styles.carouselContainer}>
            <CarouselSmallCard
              title={pageState.smallCardTitle1}
              extraText={pageState.smallCardDescription1}
              icon={pageState.arrowIconDark}
              backgroundColor="#E3F4FF"
              borderColor="#89D0FE"
              link="/contra-barrier-condom"
            />
            <CarouselSmallCard
              title={pageState.smallCardTitle2}
              extraText={pageState.smallCardDescription2}
              icon={pageState.arrowIconDark}
              backgroundColor="#E3F4FF"
              borderColor="#89D0FE"
              link="/contra-barrier-cervicalcap"
            />
          </div>
        )}
        </div>
      </div>
      <div className={styles.bottomSpace}></div>
      <BottomNavBarNew appLanguage={appLanguage}/>
    </div>
  );
}